import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiInputText from "slotworks/graphics/elements/flexi-input-text";
import Layers from "slotworks/graphics/layers/layers";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import ValueList from "slotworks/utils/value-list";
import AbstractButtonControl from "../abstract/abstract-button-control";

export default class CustomAutoplaySingleWinLimitCountButtonControl extends AbstractButtonControl implements Control {
    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.button.on(ButtonEvent.POINTER_DOWN, this.onDown);
    }

    public updateOptions(options: ControlOptions) {
        super.updateOptions(options);
        this.setButtonState();
    }

    protected onClick() {
        const options = new ControlOptions();

        options.customSingleWinLimitSelected = !this.options.customSingleWinLimitSelected;
        if (options.customSingleWinLimitSelected) {
            options.customAutoplayCountSelected = false;
            options.customLossLimitSelected = false;
        }

        options.autoplays.currentValue = this.getValidatedInt("spin_count", this.options.autoplays);
        options.lossLimit.currentValue = this.getValidatedInt("loss_limit", this.options.lossLimit);
        options.singleWinLimit.currentValue = this.getValidatedInt("single_win_limit", this.options.singleWinLimit);

        this.onChange.dispatch(options);
    }

    protected setButtonState() {
        if (this.options && this.options.customSingleWinLimitSelected) {
            this.button.setSelected(true);
        } else {
            this.button.setSelected(false);
        }
    }

    private onDown = (event: Event) => {
        event.preventDefault();
    }

    private getValidatedInt(name: string, valueList: ValueList<number>): number {
        const input = this.layer.getFlexiInputText(name);
        if (input.getVisible()) {
            let value = this.getInputAsNumber(input);

            if (isNaN(value)) {
                return undefined;
            }

            if (!Number.isInteger(value)) {
                value = +value.toFixed(0);
            }

            return valueList.getClamped(value);
        }

        return undefined;
    }

    private getInputAsNumber(input: FlexiInputText): number {
        const text = input.getText();

        return +parseFloat(text).toFixed(2);
    }
}
